import React from 'react';
import { Card, Heading, Button, Avatar } from 'components';
import { Row, Col, Tooltip, Typography } from 'antd';
import styled from 'styled-components';
import { baseStyles } from 'styles/base';
import { media, pricer, placeholderImage, renderAvatar } from 'helpers';
import { Trans } from '@lingui/macro';
import DynamicIcon from './DynamicIcon';
import { countryMap } from 'helpers/countryMapping';
import { country } from 'App';
import { LazyImage } from 'react-lazy-images';
import { HeartFilled } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Heart from './Heart';

const StyledCard = styled(Card)`
	&& {
		position: relative;
		border-radius: 12px;
		cursor: pointer;
		min-width: 200px;
		max-width: 300px;
		margin: 0 auto;
		box-shadow: ${({ boxShadow }) => boxShadow || '0 12px 20px 0 rgba(0, 0, 0, 0.1), 0 17px 10px 0 rgba(0, 0, 0, 0.1)'};
		${media.mobile`
            margin-bottom: 2em;
        `}
	}
`;

const StyledAvatar = styled(LazyImage)`
	height: 110px;
	object-fit: cover;
	margin-bottom: 1em;
	border-radius: 50%;
	${media.mobile`
		height: 130px;
	`}
`;

const TitleHeading = styled(Heading).attrs(() => ({
	level: 4,
	marginBottom: '0.5em'
}))`
	line-height: 1;
	> .ant-typography:not(h4) {
		font-size: 0.85em;
		color: ${baseStyles.greyColor};
	}
	&& {
		h4 {
			font-size: 1.1em;
			margin-bottom: 0.7em;
		}
	}
`;

// const DescriptionHeading = styled(Heading).attrs(() => ({
// 	level: 4
// }))`
// 	> .ant-typography:not(h4) {
// 		font-size: 0.85em;
// 	}
// 	h4 {
// 		font-size: 0.9em;
// 	}
// `

const BottomButton = styled.div`
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translate(-50%);
	width: 80%;
`;

const TutorCard = ({ onAddToFavorite, isFav, onRefetch, pricePerHour = '', firstName = '', lastName = '', ...props }) => {
	const { education = [], resource = {}, experienceYears = '' } = props;
	const tutorData = { ...props, firstName, lastName };
	const avatar = renderAvatar(resource.path);
	const dispatch = useDispatch();
	const experience =
		experienceYears === '0' || !experienceYears ? <Trans>No experience yet</Trans> : <Trans>{experienceYears} y exp</Trans>;
	const locexp = (
		<Typography style={{ lineHeight: 1.4, padding: "0 1rem" }}>
			<Typography.Paragraph ellipsis={{ rows: 3 }}>{props.address || <Trans>No location specified</Trans>}</Typography.Paragraph>{' '}
			<Typography.Text type="secondary">{experience}</Typography.Text>
		</Typography>
	);
	// const mostExpensive = pricePerHour.reduce(
	//     (acc, curr) => (curr.price > (acc.price || 0) ? curr.price : acc.price),
	//     {}
	// )
	// const cheapest = pricePerHour.reduceRight(
	//     (acc, curr) => (curr.price > (acc.price || 0) ? curr.price : acc.price),
	//     {}
	// )
	// const pph =
	//     pricePerHour.length > 1
	//         ? `$${cheapest} - $${mostExpensive}`
	//         : pricePerHour.map(item => `$${item.price}`)


	return (
		<StyledCard {...props} description={null} height="100%">
			<Row type="flex" justify="center" className="ta-center mb0">
				<Col lg={24}>
					{/* <Avatar src={avatar} size={75} style={{ marginBottom: ".5em" }} /> */}
					<StyledAvatar
						src={avatar}
						alt={firstName + ' ' + lastName}
						placeholder={({ imageProps, ref }) => <img ref={ref} src={placeholderImage} alt={imageProps.alt} width="100%" />}
						actual={({ imageProps }) => <Avatar {...imageProps} size={75} style={{ marginBottom: '.5em' }} />}
					/>
					<TitleHeading
						content={
							<Typography.Paragraph ellipsis={{ rows: 2 }} className="mb0">
								{firstName + ' ' + lastName}
							</Typography.Paragraph>
						}
						subheader={locexp}
					/>
					{/* <Rate value={<Trans>{rating || "no ratings received yet"}</Trans>} style={{ fontSize: ".9em" }} allowHalf disabled /> */}
				</Col>
			</Row>

			<div style={{ display: 'flex', justifyContent: 'space-around' }}>
				{/* <Col lg={24} className="ta-center">
					<DescriptionHeading subheader={((education && education[0]) || {}).name || ""} />
				</Col> */}
				<div className="ta-center">
					<Tooltip title={<Trans>Amount of testimonials received</Trans>}>
						<DynamicIcon type="icon-chat" /> <br />
						<span className="grey fs-09em">{props.testimonial || 0}</span>
					</Tooltip>
				</div>
				<div className="ta-center">
					<Tooltip title={<Trans>Price for a lesson per hour</Trans>}>
						<DynamicIcon type="icon-price_tag_usd" /> <br />
						<span className="grey fs-09em" style={{ lineHeight: 1.1 }}>
							{countryMap[country].symbol} {pricer(pricePerHour) || '0'}
						</span>
					</Tooltip>
				</div>
			</div>
			{/* <StyledIcon type="heart" fav={isFav} theme="filled" onClick={(e) => onAddToFavorite(e, isFav, tutorData)} /> */}
			<Heart tutorData={tutorData} isFav={isFav} onRefetch={onRefetch} />
			{/* <Heart /> */}

			{/* <Row type="flex" justify="space-around"> */}
			{/* <Col lg={24} className="ta-center">
					<DescriptionHeading subheader={((education && education[0]) || {}).name || ""} />
				</Col> */}
			{/* <Col lg={12} className="ta-center">
					<Tooltip title={<Trans>Amount of testimonials received</Trans>}>
						<DynamicIcon type="icon-chat" /> <br />
						<span className="grey fs-09em">{props.testimonial || 0}</span>
					</Tooltip>
				</Col>
				<Col lg={12} className="ta-center">
					<Tooltip title={<Trans>Price for a lesson per hour</Trans>}>
						<DynamicIcon type="icon-price_tag_usd" /> <br />
						<span className="grey fs-09em" style={{ lineHeight: 1.1 }}>
							{countryMap[country].symbol} {pricer(pricePerHour) || '0'}
						</span>
					</Tooltip>
				</Col>
			</Row> */}
			<BottomButton>
				<Button block type="primary" size="medium">
					<Trans>See profile</Trans>
				</Button>
			</BottomButton>
		</StyledCard>
	);
};
export default TutorCard;
